/** One save at a time; a flush includes edits made while its request runs. */
export function createSerializedEditorSave({ read, save, onSaved, onError }) {
  let inFlight = null;
  return function flush() {
    if (inFlight) return inFlight;
    inFlight = Promise.resolve().then(async () => {
      for (;;) {
        const snapshot = read();
        if (!snapshot.dirty || !snapshot.id) return true;
        let result;
        try {
          result = await save(snapshot.id, snapshot.value);
        } catch (error) {
          const current = read();
          if (current.id === snapshot.id) onError(error);
          return false;
        }
        const current = read();
        if (current.id === snapshot.id && current.value === snapshot.value) {
          onSaved(result);
          return true;
        }
        // A newer edit or file selection arrived. Never acknowledge the old
        // response as current; save the latest dirty snapshot next.
      }
    }).finally(() => { inFlight = null; });
    return inFlight;
  };
}
